import Controller from "@ember/controller"
import { get } from "@ember/object"
import { inject as service } from "@ember/service"

export default class ShowController extends Controller {
  queryParams = ["redirectToPlanbookId"]

  @service
  rpc

  @service("ember-store")
  store

  @service
  session

  init() {
    super.init(...arguments)
    this.referralEmails = null
    if (window) {
      window.CCIMPERSONATE_USER = () => {
        get(this, "session").impersonateUserId(get(this, "model.id"), window.location.href)
      }
    }
  }
}
